import { Button, ButtonProps } from "@/components/Button";
import { BuilderBlockProps, CustomUrl, Size, Theme } from "@/types";
import { FC } from "react";
import { track } from "@builder.io/sdk-react";
import { getHrefFromCustomUrlPlugin } from "@/helpers";

type SharedProps = {
  text: string;
  size?: Size;
  theme?: Theme;
  dld: string;
  dlt: string;
  href?: CustomUrl;
  trackingMetric?: string;
};

type VariantProps =
  | {
      variant: "primary";
      iconPrimary?: "arrowRight" | "none";
    }
  | {
      variant: "secondary";
      iconPrimary?: "arrowRight" | "none";
    }
  | {
      variant: "tertiary";
      iconPosition?: "left" | "right";
      icon?:
        | "arrowRight"
        | "arrowDown"
        | "arrowLeft"
        | "arrowUp"
        | "circleArrowRight"
        | "circleArrowLeft"
        | "circleArrowUp"
        | "circleArrowDown"
        | "solidArrowLeft"
        | "none";
      renderLeftBorder?: boolean;
    };

export type ButtonBlockProps = SharedProps & VariantProps & BuilderBlockProps;

export const ButtonBlock: FC<ButtonBlockProps> = ({
  dld,
  dlt,
  text,
  attributes,
  href,
  trackingMetric,
  ...props
}) => {
  const url = href ? getHrefFromCustomUrlPlugin(href) : "";

  let buttonProps: ButtonProps;

  if (props.variant === "primary" || props.variant === "secondary") {
    const { iconPrimary, ...rest } = props;
    buttonProps = {
      ...rest,
      icon: iconPrimary,
    } as ButtonProps;
  } else {
    buttonProps = { ...props } as ButtonProps;
  }

  return (
    <Button
      data-linktype={dlt}
      data-linkdetail={dld}
      {...attributes}
      {...buttonProps}
      href={url}
      onClick={async (event: unknown) => {
        await attributes?.onClick?.(event);
        await track({
          type: "conversion",
          apiKey: process.env.NEXT_PUBLIC_BUILDER_API_KEY as string,
        });
        if (trackingMetric) {
          await track({
            type: trackingMetric,
            apiKey: process.env.NEXT_PUBLIC_BUILDER_API_KEY as string,
          });
        }
      }}
    >
      {text}
    </Button>
  );
};
